import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable()
export class MockInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url === '/api/upload-template') {
      const mockResponse = {
        status: 200,
        message: 'Template uploaded successfully!',
        data: { id: '12345', fileName: 'template.pdf' }
      };
      return of(new HttpResponse({ status: 200, body: mockResponse }));
    }
    return next.handle(req);
  }
}
